// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CourseSimulatorDetails.css */

.course-simulator-details {
    background-color: #013020;
    color: #ffcb00;
    padding: 20px;
}

.search-box {
    margin-bottom: 20px;
    position: relative;
}

#search-input {
    width: 100%;
    padding: 12px;
    font-size: 16px;
    background-color: #013020;
    border: 2px solid #265d38;
    border-radius: 5px;
    color: #ffcb00;
}

#search-input::placeholder {
    color: #6b8e76;
}

.loading, .error {
    margin-top: 10px;
    padding: 10px;
    border-radius: 4px;
}

.error {
    color: #ff6b6b;
    background-color: #2e1a1a;
    border: 1px solid #ff6b6b;
}

#search-results {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    background-color: #013020;
    border: 2px solid #265d38;
    border-top: none;
    border-radius: 0 0 5px 5px;
    max-height: 200px;
    overflow-y: auto;
    z-index: 1000;
}

.course-result {
    padding: 10px;
    cursor: pointer;
    color: #ffcb00;
}

.course-result:hover {
    background-color: #265d38;
}

#requirements {
    background-color: #013020;
    padding: 20px;
    border-radius: 4px;
}

#requirements h2 {
    margin-top: 0;
    color: #ffcb00;
}

/* Styles for the different requirement sections */
.requirement-section {
    margin-bottom: 20px;
    padding: 15px;
    background-color: #265d38;
    border: 1px solid #ffcb00;
    border-radius: 4px;
}

.requirement-section h3 {
    margin-top: 0;
    color: #ffcb00;
}

.course-list {
    list-style-type: none;
    padding: 0;
}

.course-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
    border-bottom: 1px solid #ffcb00;
}

.course-item:last-child {
    border-bottom: none;
}

.remove-course {
    background-color: #ff4d4d;
    color: #013020;
    border: none;
    padding: 5px 10px;
    border-radius: 3px;
    cursor: pointer;
}

.remove-course:hover {
    background-color: #ff3333;
}

/* Android-like Spinner animation */
@keyframes androidSpinner {
    0% { transform: rotate(0deg); }
    50% { transform: rotate(180deg); }
    100% { transform: rotate(360deg); }
}

.android-spinner {
    border: 4px solid transparent;
    border-radius: 50%;
    border-top: 4px solid #ffcb00;
    width: 40px;
    height: 40px;
    animation: androidSpinner 1s linear infinite;
    margin: 20px auto;
}`, "",{"version":3,"sources":["webpack://./src/CourseSimulatorDetails.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;IACI,yBAAyB;IACzB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,yBAAyB;IACzB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA,kDAAkD;AAClD;IACI,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mCAAmC;AACnC;IACI,KAAK,uBAAuB,EAAE;IAC9B,MAAM,yBAAyB,EAAE;IACjC,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,6BAA6B;IAC7B,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,4CAA4C;IAC5C,iBAAiB;AACrB","sourcesContent":["/* CourseSimulatorDetails.css */\n\n.course-simulator-details {\n    background-color: #013020;\n    color: #ffcb00;\n    padding: 20px;\n}\n\n.search-box {\n    margin-bottom: 20px;\n    position: relative;\n}\n\n#search-input {\n    width: 100%;\n    padding: 12px;\n    font-size: 16px;\n    background-color: #013020;\n    border: 2px solid #265d38;\n    border-radius: 5px;\n    color: #ffcb00;\n}\n\n#search-input::placeholder {\n    color: #6b8e76;\n}\n\n.loading, .error {\n    margin-top: 10px;\n    padding: 10px;\n    border-radius: 4px;\n}\n\n.error {\n    color: #ff6b6b;\n    background-color: #2e1a1a;\n    border: 1px solid #ff6b6b;\n}\n\n#search-results {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    right: 0;\n    background-color: #013020;\n    border: 2px solid #265d38;\n    border-top: none;\n    border-radius: 0 0 5px 5px;\n    max-height: 200px;\n    overflow-y: auto;\n    z-index: 1000;\n}\n\n.course-result {\n    padding: 10px;\n    cursor: pointer;\n    color: #ffcb00;\n}\n\n.course-result:hover {\n    background-color: #265d38;\n}\n\n#requirements {\n    background-color: #013020;\n    padding: 20px;\n    border-radius: 4px;\n}\n\n#requirements h2 {\n    margin-top: 0;\n    color: #ffcb00;\n}\n\n/* Styles for the different requirement sections */\n.requirement-section {\n    margin-bottom: 20px;\n    padding: 15px;\n    background-color: #265d38;\n    border: 1px solid #ffcb00;\n    border-radius: 4px;\n}\n\n.requirement-section h3 {\n    margin-top: 0;\n    color: #ffcb00;\n}\n\n.course-list {\n    list-style-type: none;\n    padding: 0;\n}\n\n.course-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 5px 0;\n    border-bottom: 1px solid #ffcb00;\n}\n\n.course-item:last-child {\n    border-bottom: none;\n}\n\n.remove-course {\n    background-color: #ff4d4d;\n    color: #013020;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 3px;\n    cursor: pointer;\n}\n\n.remove-course:hover {\n    background-color: #ff3333;\n}\n\n/* Android-like Spinner animation */\n@keyframes androidSpinner {\n    0% { transform: rotate(0deg); }\n    50% { transform: rotate(180deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.android-spinner {\n    border: 4px solid transparent;\n    border-radius: 50%;\n    border-top: 4px solid #ffcb00;\n    width: 40px;\n    height: 40px;\n    animation: androidSpinner 1s linear infinite;\n    margin: 20px auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
